import React from 'react';
import { Box, Flex } from '../ui';
import { ColorProps, SpaceProps } from 'styled-system';

interface PrintsSupplyProps {
  supply: number;
  balance?: any;
  hideBalance?: boolean;
  showLabel?: boolean;
}

const PrintsSupply: React.FC<PrintsSupplyProps & SpaceProps & ColorProps> = ({
  supply,
  balance,
  showLabel,
  hideBalance = false,
  ...rest
}) => {
  const suffix = showLabel ? '' : ` in Supply`

  return (
    <Flex column>
      {
        showLabel && (
          <Box fontSize="12px" display={['none', 'none', 'block']} mr="2">
            Current Supply
          </Box>
        )
      }
      <Flex alignCenter {...rest}>
        <Box color="copy" fontSize="2" alignSelf="center">
          {(balance && !hideBalance) ? `${balance} of ${supply}` : `${supply} Print${supply !== 1 ? 's' : ''}${suffix}`}
        </Box>
      </Flex>
    </Flex>
  );
};

export default PrintsSupply;
